// The bug glyph used by the header's report-a-problem button. Shared so the
// news popup can show the exact same symbol inline in a body text that tells
// the reader where to click.
export default function BuggIkon({ className = "w-5 h-5" }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.75}
      aria-hidden="true"
    >
      {/* Stiliserad bug: oval kropp + antenner + ben */}
      <ellipse cx="12" cy="13" rx="5" ry="6" />
      <line x1="12" y1="7" x2="12" y2="19" />
      <line x1="9.5" y1="6" x2="8" y2="3.5" />
      <line x1="14.5" y1="6" x2="16" y2="3.5" />
      <line x1="7" y1="11" x2="4" y2="10" />
      <line x1="7" y1="14" x2="4" y2="14" />
      <line x1="7" y1="17" x2="4" y2="18" />
      <line x1="17" y1="11" x2="20" y2="10" />
      <line x1="17" y1="14" x2="20" y2="14" />
      <line x1="17" y1="17" x2="20" y2="18" />
    </svg>
  );
}
